import React from "react";

const ChapterHeader = ({
    chapterName,
    chapterPages,
    isChapterOpen,
    toggleChapter,

    notebookPages,
    setNotebookPages,
    notebookPagesStorageKey,

    setExpandedChapters,

    notebookChapters,
    saveNotebookChapters,
    }) => {
    const [
        isRenameOpen,
        setIsRenameOpen,
    ] = React.useState(false);

    const [
        renameDraft,
        setRenameDraft,
    ] = React.useState("");
    const openRenameChapter = () => {
        if (
            chapterName ===
            "Unassigned"
        ) {
            return;
        }

        setRenameDraft(
            chapterName
        );

        setIsRenameOpen(
            true
        );
    };

    const saveRenamedChapter = () => {
        const cleanName =
            renameDraft.trim();

        if (
            !cleanName ||
            cleanName ===
                chapterName
        ) {
            setIsRenameOpen(
                false
            );

            return;
        }

        const timestamp =
            new Date().toISOString();

        const updatedPages =
            notebookPages.map(
                (page) =>
                    (
                        page.chapterTitle?.trim() ||
                        "Unassigned"
                    ) === chapterName
                        ? {
                            ...page,
                            chapterTitle:
                                cleanName,
                            updatedAt:
                                timestamp,
                        }
                        : page
            );

        setNotebookPages(
            updatedPages
        );

        try {
            localStorage.setItem(
                notebookPagesStorageKey,
                JSON.stringify(
                    updatedPages
                )
            );
        } catch (error) {
            console.error(
                "Unable to rename chapter:",
                error
            );
        }

        const updatedChapters =
            notebookChapters.map(
                (name) =>
                    name === chapterName
                        ? cleanName
                        : name
            );

        saveNotebookChapters(
            updatedChapters
        );

        setExpandedChapters(
            (current) => {
                const next = {
                    ...current,
                };

                delete next[
                    chapterName
                ];

                next[cleanName] =
                    true;

                return next;
            }
        );

        setIsRenameOpen(false);
        setRenameDraft("");
    };

    return (
    <>
        <div
            className="
                flex
                w-full
                items-center
                justify-between
                gap-2
                px-3
                py-2.5
            "
        >
            <button
                type="button"
                onClick={() =>
                    toggleChapter(
                        chapterName
                    )
                }
                className="
                    flex
                    min-w-0
                    flex-1
                    items-center
                    justify-between
                    gap-3
                    text-left
                    transition
                    hover:text-[#ffd166]
                "
            >
                <div className="min-w-0">
                    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#ffd166]">
                        {chapterName}
                    </p>

                    <p className="mt-0.5 text-[10px] text-[#8f98b5]">
                        {
                            chapterPages.length
                        }{" "}
                        lesson
                        {chapterPages.length ===
                        1
                            ? ""
                            : "s"}
                    </p>
                </div>

                <span className="shrink-0 text-xs text-[#d8b4fe]">
                    {isChapterOpen
                        ? "▼"
                        : "▶"}
                </span>
            </button>

            {chapterName !==
                "Unassigned" && (
                <button
                    type="button"
                    onClick={
                        openRenameChapter
                    }
                    className="
                        shrink-0
                        rounded-lg
                        border
                        border-[#c084fc]/30
                        bg-black
                        px-2
                        py-1
                        text-[10px]
                        text-[#d8b4fe]
                        transition
                        hover:border-[#ffd166]
                        hover:text-[#ffd166]
                    "
                >
                    Rename
                </button>
            )}
        </div>
        {isRenameOpen && (
            <div
                className="
                    fixed
                    inset-0
                    z-[99999]
                    flex
                    items-center
                    justify-center
                    bg-black/85
                    px-4
                    backdrop-blur-sm
                "
            >
                <div
                    className="
                        w-full
                        max-w-md
                        rounded-[28px]
                        border
                        border-[#ffd166]/45
                        bg-[#05070d]
                        p-6
                        shadow-[0_0_40px_rgba(255,209,102,0.18)]
                    "
                >
                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#d8b4fe]">
                        Edit Chapter
                    </p>

                    <h3 className="mt-2 font-display text-2xl text-[#ffd166]">
                        Rename Chapter
                    </h3>

                    <p className="mt-2 text-xs text-[#b0b8d6]">
                        Update the chapter name throughout this notebook.
                    </p>

                    <label className="mt-5 mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-[#ffd166]">
                        Chapter Name
                    </label>

                    <input
                        type="text"
                        value={
                            renameDraft
                        }
                        onChange={(event) =>
                            setRenameDraft(
                                event.target.value
                            )
                        }
                        onKeyDown={(event) => {
                            if (
                                event.key ===
                                "Enter"
                            ) {
                                saveRenamedChapter();
                            }
                        }}
                        autoFocus
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#ffd166]/30
                            bg-[#080b14]
                            px-3
                            py-2
                            text-sm
                            text-[#fff3c4]
                            outline-none
                            focus:border-[#ffd166]
                        "
                    />

                    <div className="mt-6 flex justify-end gap-2">
                        <button
                            type="button"
                            onClick={() => {
                                setIsRenameOpen(
                                    false
                                );

                                setRenameDraft(
                                    ""
                                );
                            }}
                            className="
                                rounded-xl
                                border
                                border-[#c084fc]/35
                                bg-black
                                px-4
                                py-2
                                text-xs
                                font-semibold
                                text-[#d8b4fe]
                                transition
                                hover:border-[#c084fc]/70
                                hover:text-[#f3e8ff]
                            "
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            onClick={
                                saveRenamedChapter
                            }
                            className="
                                rounded-xl
                                border
                                border-[#ffd166]/50
                                bg-[#2b1548]/80
                                px-4
                                py-2
                                text-xs
                                font-semibold
                                text-[#ffd166]
                                transition
                                hover:border-[#ffd166]
                                hover:bg-[#ffd166]/10
                            "
                        >
                            Save Name
                        </button>
                    </div>
                </div>
            </div>
)}

    </>

    );
};

export default ChapterHeader;